<button class="btn-hotel-wishlist"
        [disabled]="isLoading"
        [ngClass]="getButtonClasses()"
        (click)="triggerBtn()">
    <img [src]="isLike ? '/x-assets/img/icons/icon-filled-heart.svg' : '/x-assets/img/icons/icon-unfilled-heart-blue.svg'"
         [alt]="isLike ? 'Like' : 'Unlike'"/>
</button>
@if (isPopupVisible) {
    <app-hotel-wishlist-popup [isAdded]="popupState.isAdded" [@fadeInOut]="popupState.isVisible"/>
}
